import type { App } from 'vue';
import type { Router } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useGettext } from 'vue3-gettext';
import { auth } from '@vp/vue-components';

export const handleSessionLapse = (app: App, router: Router) => app.runWithContext(() => {
  const { fullPath } = router.currentRoute.value;

  auth.useAuthStore().logout();
  // Redirect before the toast, so a failing toast cannot leave the signed-out user on the shell.
  void router.push({ name: 'Login', query: { redirect: fullPath } });

  const { $gettext } = useGettext();
  useToast().warning($gettext('Your session has expired. Please sign in again to continue.'));
});
